import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../reducers/modalSlice";
import { addLink, removeLink } from "../../../reducers/app";
import { CONSTRUCTOR_EVENTS, gtagEvent } from "../../../utils/analytics";

export const ASSENTS_LINKS = "assetsLinks"

export default function CssLinkModal() {
  const dispatch = useDispatch();
  const links = useSelector((state) => state.appStorage.links);
  const activeModalName = useSelector((state) => state.modal.activeModal)

  const isVisible = activeModalName === "css-link-modal";

  const [link, setLink] = useState("");

  useEffect(() => {
      localStorage.setItem(ASSENTS_LINKS, JSON.stringify(links))
  }, [links])

  const handleChange = (e) => {
    setLink(e.target.value);
  };

  const handleRemoveLink = (index) => {
    dispatch(removeLink(index));
  };

  useEffect(() => {
    if (isVisible) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isVisible]);

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      dispatch(closeModal())
    }
  };

  return (
      <>
        {isVisible && <div className="modal-backdrop show"></div>}
        <div
            className={`modal ${isVisible ? "show" : ""}`}
            id="css-link-modal"
            tabIndex="-1"
            style={{ display: isVisible ? "block" : "none" }}
            onClick={handleClickOutside}
            role={isVisible ? "dialog" : ""}
        >
          <div className="modal-dialog cssLinkModal">
            <div className="modal-content">
              <div className="modal-header border-bottom-0 d-flex align-items-center justify-content-between cursor-pointer">
                <h5 className="modal-title text-dark-gray fs-4">CSS Link</h5>
                <i className="bi bi-x text-dark-gray fs-3"
                    onClick={() => dispatch(closeModal())}>
                </i>
              </div>
              <div className="modal-body px-4">
                <textarea
                    className="col-12 rounded-1"
                    value={link}
                    onChange={handleChange}
                    placeholder="Enter CSS Link or Script"
                />
                {links.length > 0 && <ul className="d-grid gap-3 link-list list-unstyled mt-4 mb-0 text-break">
                  {links.map((linkItem, index) => (
                      <li key={index} className="link-item py-2 bg-main-background text-dark-gray position-relative rounded-2">
                        <p className="col-11">{linkItem}</p>
                          <i className="bi bi-trash text-danger cursor-pointer position-absolute" 
                          onClick={() => handleRemoveLink(index)}
                          ></i>
                      </li>
                  ))}
                </ul>}
              </div>
              <div className="modal-footer border-top-0 d-flex align-items-center justify-content-between">
                <button
                    type="button"
                    className="btn btn-outline-dark-gray py-2"
                    onClick={() => dispatch(closeModal())}
                >
                  Close
                </button>
                <button
                    type="button"
                    className="btn btn-primary fw-bold py-2"
                    onClick={() => {
                      if (link.trim()) {
                        gtagEvent(CONSTRUCTOR_EVENTS.EDIT_CSS);
                        dispatch(addLink(link));
                        setLink("");
                      }
                    }}
                >
                  Save <span className="d-none d-md-inline">Changes</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}
